/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NotificationCenterFilter } from '../models/NotificationCenterFilter';
import type { NotificationCountFilter } from '../models/NotificationCountFilter';
import type { NotificationCountResponse } from '../models/NotificationCountResponse';
import type { PaginatedResponse_NotificationResponse_ } from '../models/PaginatedResponse_NotificationResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MobileNotificationCenterService {
    /**
     * List mobile user's notifications
     * List the authenticated mobile user's notifications, urgent first then newest first
     * @param filter
     * @param skip
     * @param limit
     * @param xMobileAuth
     * @returns PaginatedResponse_NotificationResponse_ Successful Response
     * @throws ApiError
     */
    public static listNotificationsV1(
        filter?: (NotificationCenterFilter | null),
        skip?: number,
        limit: number = 100,
        xMobileAuth?: (string | null),
    ): CancelablePromise<PaginatedResponse_NotificationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mobile/v1/notification-center/',
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            query: {
                'filter': filter,
                'skip': skip,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Count mobile user's notifications
     * Count the authenticated mobile user's notifications; the pending filter is the tab badge, polled while the center is closed
     * @param filter
     * @param xMobileAuth
     * @returns NotificationCountResponse Successful Response
     * @throws ApiError
     */
    public static countNotificationsV1(
        filter?: (NotificationCountFilter | null),
        xMobileAuth?: (string | null),
    ): CancelablePromise<NotificationCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mobile/v1/notification-center/count',
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            query: {
                'filter': filter,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Mark a notification as read
     * Mark one of the authenticated mobile user's notifications as read
     * @param notificationId
     * @param xMobileAuth
     * @returns any Successful Response
     * @throws ApiError
     */
    public static markNotificationReadV1(
        notificationId: string,
        xMobileAuth?: (string | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mobile/v1/notification-center/{notification_id}/read',
            path: {
                'notification_id': notificationId,
            },
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Archive a notification
     * Archive one of the authenticated mobile user's notifications
     * @param notificationId
     * @param xMobileAuth
     * @returns any Successful Response
     * @throws ApiError
     */
    public static archiveNotificationV1(
        notificationId: string,
        xMobileAuth?: (string | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mobile/v1/notification-center/{notification_id}/archive',
            path: {
                'notification_id': notificationId,
            },
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
